import React, { useRef } from "react";
import { Box } from "rebass";

const Progress = ({ max, value, sx = {}, color, bgColor = 'text', setClickedTime = () => null, borderRadius, ...props }) => {
	const barRef = useRef(null);
	return (
		<Box
			ref={barRef}
			onClick={(e) => {
				if (barRef.current) {
					const clickPositionInPage = e.pageX;
					const barStart = barRef.current.getBoundingClientRect().left + window.scrollX;
					const barWidth = barRef.current.offsetWidth;
					const clickPositionInBar = clickPositionInPage - barStart;
					const timePerPixel = max / barWidth;
					setClickedTime(timePerPixel * clickPositionInBar);
				}
			}}
			height={3}
			bg={bgColor}
			{...props}
			sx={{ ...sx, position: 'relative', borderRadius }}
		>
			<Box
				sx={{
					transformOrigin: 'left center',
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%',
					background: color,
				}}
				style={{
					transform: `scaleX(${Math.floor(100 * value / max) / 100})`
				}}
			/>
		</Box>
	);
};

export default Progress;